export type Theme = "light" | "dark" | "system";

const KEY = "pw.theme";

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch { /* приватный режим */ }
  return "system";
}

export function applyTheme(t: Theme) {
  const root = document.documentElement;
  if (t === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", t);
  try { localStorage.setItem(KEY, t); } catch { /* приватный режим */ }
}

export const nextTheme = (t: Theme): Theme =>
  t === "system" ? "light" : t === "light" ? "dark" : "system";

/** Реально ли сейчас темно — нужно, чтобы подобрать плотность подложки под фото. */
export const isDark = (t: Theme): boolean =>
  t === "dark" || (t === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
